import { CircularProgress, Container, Grid, SvgIcon, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import MessageBox from '../MessageBox';

function NSHInfographic() {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [total, setTotal] = useState(null);
  const [nshOperating, setNSHOperating] = useState(null);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    // Instantiate a new server to define where the RDS API is hosted.
    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);

    function getCapacity() {
      // Instantiate a catalog that exists on the server
      // const catalog = new RdsCatalog(server, 'ccdc');
      // Instantiate a data product that exists on the catalog
      // const dataProduct = new RdsDataProduct(catalog, 'provider');

      const whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND license_type=LIC`;

      return rdsTabulate('ccdc', 'provider', {
        dims: 'operating_during_nsh',
        measure: 'count:COUNT(*)',
        where: whereClause,
        format: 'amcharts',
      });
    }

    setReady(false);
    setError(null);
    Promise.all([getCapacity()])
      .then((responses) => {
        if (responses[0].parsedBody.dataProvider.length > 0) {
          let totalCount = 0;
          let nsh = 0;
          responses[0].parsedBody.dataProvider.forEach((d) => {
            if (d.operating_during_nsh === 1) {
              nsh += d.count;
            }
            totalCount += d.count;
          });
          setTotal(totalCount);
          setNSHOperating(nsh);
        } else {
          setError(new Error('No data returned'));
          setTotal(null);
          setNSHOperating(null);
        }
      })
      .catch((rdsError) => {
        // console.error(rdsError);
        setError(rdsError);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  if (!ready) {
    return (
      <Grid container justify="center">
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  function displayText() {
    if (nshOperating && total) {
      return (
        <Typography variant="body1" align="left">
          In <b>{states[stateCode.toUpperCase()]}</b>, <b>{toFormattedNumber(nshOperating)}</b> providers offer NSH care for infants, toddlers, and preschoolers.
          <br />
          <b>{toFormattedNumber((nshOperating / total) * 100)}</b> of every 100 providers offer NSH care.
        </Typography>
      );
    }

    return (
      <Typography variant="body1" align="left">
        Not reported.
      </Typography>
    );
  }

  return (
    <Grid container spacing={2} justify="center">
      <Grid item xs={12} md={8}>
        {error && <Typography variant="body1" align="center" color="error">{error.message}</Typography>}
        <MessageBox>
          {displayText()}
        </MessageBox>
      </Grid>
      <Grid item xs={12}>
        <Container style={{ textAlign: 'center' }}>
          <SvgIcon style={{ fontSize: '16em' }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="2 1.5 20 21">
              <defs>
                <linearGradient id="nshGradient" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor={primaryColor} />
                  <stop offset={`${(nshOperating / total) * 100}%`} stopColor={primaryColor} />
                  <stop offset={`${(nshOperating / total) * 100 + 0.1}%`} stopColor={secondaryColor} />
                  <stop offset="100%" stopColor={secondaryColor} />
                </linearGradient>
              </defs>
              <g fill="url('#nshGradient')">
                <path d="M22,5.72l-4.6-3.86l-1.291,1.53l4.601,3.86L22,5.72z M7.88,3.39L6.6,1.86L2,5.71l1.29,1.53L7.88,3.39z M12.5,8H11v6
	l4.75,2.85l0.75-1.229l-4-2.37V8z M12,4c-4.97,0-9,4.03-9,9s4.02,9,9,9c4.971,0,9-4.03,9-9S16.971,4,12,4z M12,20
	c-3.87,0-7-3.13-7-7s3.13-7,7-7s7,3.13,7,7S15.87,20,12,20z"/>
              </g>
            </svg>
          </SvgIcon>
        </Container>
      </Grid>
    </Grid>
  );
}

export default NSHInfographic;
